<template>
    <v-row class="fill-height">
        <v-col
            class="pa-0"
            :cols="$vuetify.breakpoint.mdAndDown ? 12 : 4">
            <v-card
                class="col-login-left"
                flat
                tile
                dark>
                <v-img
                    contain
                    class="my-5"
                    max-height="25px"
                    src="/img/logo.png" />

                <v-form
                    style="width: 80%;"
                    ref="form"
                    @submit.prevent="submit"
                    v-model="valid"
                    method="post">
                    <v-card-title class="font-weight-bold">
                        Forgot Password
                    </v-card-title>

                    <v-card-text>
                        <v-text-field
                            outlined
                            name="email"
                            label="Email"
                            type="email"
                            v-model="email"
                            :rules="rules.email"
                            required />
                    </v-card-text>

                    <v-card-actions class="px-4">
                        <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            block
                            dark
                            type="submit">
                            Send reset link
                        </v-btn>
                    </v-card-actions>

                    <v-card-actions class="px-4">
                        <v-spacer />

                        <router-link
                            :to="{name: 'login'}"
                            class="white--text font-weight-bold caption">
                            Sign In
                        </router-link>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-col>

        <v-col
            class="col-login-right"
            v-if="$vuetify.breakpoint.lgAndUp"
            :cols="8">
            <v-row>
                <v-col
                    cols="12"
                >
                    <v-skeleton-loader
                        :aria-busy="false"
                        type="card-avatar, article, actions"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
    data() {
        return {
            loading: false,
            valid: false,
            email: '',
            show_password: false,
            rules: {
                email: [
                    v => (new Validation(this)).ruleRequired(v, 'Email'),
                    v => (new Validation(this)).ruleEmail(v, 'Email')
                ],
            }
        };
    },

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
        }),
    },

    mounted() {
    },

    methods: {
        ...mapActions({
            forgotPassword: 'auth/forgotPassword',
        }),

        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            let credentials = {
                email: this.email,
            };

            this
                .forgotPassword(credentials)
                .then((response) => {
                    (new SuccessAlert(this))
                        .setMessage(response.data.message)
                        .show();

                    this.$router.replace({name: 'home'});
                })
                .catch((error) => {
                    (new ErrorAlert(this))
                        .setMessage(error.response.data.message)
                        .show();
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
